window['FLS_SWITCH'] = true;

import * as flsFunctions from './files/functions.js';
flsFunctions.isWebp();

import { initSidebarSticky } from './files/scroll/sidebar-sticky.js';
initSidebarSticky();

import {
	initBannerResize,
	initContentBannerResize,
	resizeContentBanners,
} from './files/banner-resize.js';
initBannerResize();
initContentBannerResize();
window.resizeContentBanners = resizeContentBanners;
